import type { IconProps } from './../../models/icon';

export function RefinanceIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M11.8951 21.7232C17.265 21.7232 21.6183 17.37 21.6183 12C21.6183 6.62997 17.265 2.27673 11.8951 2.27673C6.5251 2.27673 2.17188 6.62997 2.17188 12C2.17188 17.37 6.5251 21.7232 11.8951 21.7232Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M13.5329 8.22449C13.1676 8.22449 12.4723 8.22449 11.7633 8.22449C10.786 8.22449 9.99365 9.01676 9.99365 9.99411C9.99365 10.9714 10.7859 11.7637 11.7633 11.7637C12.7406 11.7637 13.5329 12.556 13.5329 13.5333C13.5329 14.5107 12.7406 15.303 11.7633 15.303H9.99365"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M11.7627 8.22519V6.45557"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M11.7627 17.0755V15.3059"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M2.45801 9.64943C3.50919 5.41508 7.33567 2.27673 11.8952 2.27673C16.4546 2.27673 20.281 5.41508 21.3322 9.64943"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M21.3322 14.3506C20.2812 18.585 16.4546 21.7233 11.8952 21.7233C7.33568 21.7233 3.50921 18.585 2.45801 14.3506"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M18.3213 8.25189L21.4017 9.7251L22.6874 6.7251"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M5.59689 15.7137L2.4805 14.3182L1.27051 17.3496"
      />
    </svg>
  );
}
